import { LOCALES } from 'i18n/locales';

export const mapMenuIntl = {
    [LOCALES.ENGLISH]: {
        'mapMenu.button.ariaLabel': 'Map menu'
    },
    [LOCALES.WELSH]: {
        'mapMenu.button.ariaLabel': 'Dewislen map'
    }
};
